import type { PublicCall } from "@/frontend/stores/callStore";

export function formatCallDuration(seconds: number | null | undefined) {
  if (seconds == null) return "";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = String(seconds % 60).padStart(2, "0");
  return hours > 0 ? `${hours}:${String(minutes).padStart(2, "0")}:${rest}` : `${minutes}:${rest}`;
}

/** "answered by Asha", "declined by Ravi": who on the team handled the call. */
export function callTeammateText(call: PublicCall) {
  if (call.direction === "outbound") return call.placedByName ? `by ${call.placedByName}` : "";
  if (call.status === "declined" && call.endedByName) return `declined by ${call.endedByName}`;
  return call.answeredByName ? `answered by ${call.answeredByName}` : "";
}

/** Whether to offer calling the customer back: a customer's call we didn't get to talk on. */
export function needsCallBack(call: PublicCall) {
  return call.direction === "inbound" && ["missed", "declined", "voicemail"].includes(call.status);
}

/** Whether CallTranscript has anything to show for this call. */
export function showsTranscript(call: PublicCall) {
  return call.transcriptStatus === "available" || call.transcriptStatus === "failed" ||
    (call.transcriptStatus === "pending" && call.status === "completed");
}

